<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Vertragsnummer auswählen"}}</h4>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-xs-12">
            <div class="form-group">
                {{#SELECT contractNr}}
                <select
                    class="selectpicker js-contract"
                    data-live-search="true"
                    data-style="btn-white"
                    data-title="{{TR 'Vertragsnummer auswählen'}}">
                    {{#each contractNrList}}
                        <option value="{{idx}}">{{nr}}</option>
                    {{/each}}
                </select>
                {{/SELECT}}
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-success">{{TR "Speichern"}}</button>
</div>
